module.exports = __webpack_public_path__ + "static/media/Rowlet_gaussian2.a9e0e892.png";